import { IMISDownloadsService } from "../../../Types/MISDownload";
import ApiService from "../../ApiService";

enum MisEndpoints {
  DOWNLOADS = "/downloads",
}
class MISDownloadsService extends ApiService {
  async getMisDownloads(folderId?: string): Promise<IMISDownloadsService> {
    return this.get<IMISDownloadsService>(
      folderId
        ? `${MisEndpoints.DOWNLOADS}/${folderId}`
        : MisEndpoints.DOWNLOADS
    );
  }
}

export const misDownloadService = new MISDownloadsService();
